// extracted by mini-css-extract-plugin
export default {"mCard":"qA-z","image":"rA-z","imageNoBackground":"sA-z","imageHasCategory":"tA-z","fullWidth":"uA-z"};